export default "__VITE_ASSET__Dv4CgOy3__"